import { NgModule } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
//import { Produto, Categoria, Adicionais } from '../cardapio';
import { Router } from '@angular/router';
//import { AlertaConfirmDialog } from '../alerta-confirm';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
    selector: 'app-inicio',
    templateUrl: './inicio.component.html',
    styleUrls: ['./inicio.component.css']
  })

export class InicioComponent implements OnInit {
    shouldHide: boolean = true;
    shouldHide2: boolean = false;
    shouldHide3: boolean = true;
    produtoSelecionado: any[]  = [];
    inputsearch: any = '';
    contadorAdmin: any = 0;
    hideCL: boolean = false;
    constructor( public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog) {}

    ngOnInit() {
        this.hideCL = true;
        if(!this.tmaService.logado){
            //redirecionar para login
            
        }
    }
    
    goCEP() :void{
        this.tmaService.pickCidade = true;
        this.router.navigate(['cidades/']);
    }

    goHome() :void{
        //configurar mode
        localStorage.removeItem("turboMode");
        localStorage["turboMode"] = JSON.stringify({ modo: "Retirada" });
        this.router.navigate(['home/']);
        //this.router.navigate(['cidades/']);
    }

    goDev() :void{
        (<any>window).ga('send', 'event', {
            eventCategory: 'Clicou',
            eventLabel: 'URL para Collegare',
            eventAction: 'Site Collegare',
            eventValue: 10
          });
          window.open('http://collegare.com.br', '_blank');
    }

    detalhesRefeicao(idDieta: any , diaSemana: any, idRefeicao: any, diaMes: any) :void{
        this.tmaService.qPagina = "home";
        this.router.navigate(['/me/refeicao/' + idDieta + "/" + diaSemana + "/" + idRefeicao + "/" + diaMes]);
    }



        
        

}
